import type { BranchModule } from './types'

/** Whether a branch holds a per-branch module, and whether the switch can be
 *  moved. Three ways a switch is locked: not bought at all, bought for every
 *  branch at once (nothing to choose), or bought for some branches and this one
 *  is not among the holders while every seat is already taken. */
export function branchModuleState(
  m: BranchModule,
  branchId: string,
): { on: boolean; locked: boolean; reason?: 'notBought' | 'every' | 'full' } {
  if (!m.bought) return { on: false, locked: true, reason: 'notBought' }
  if (m.every) return { on: true, locked: true, reason: 'every' }
  // heldIds rather than branchIds alone: a retired branch holds no seat but still
  // carries its row, and it must read as on and switchable so the row can be
  // taken off — that is the only way it can come back while the seats are full.
  const on = m.branchIds.includes(branchId) || (m.heldIds ?? []).includes(branchId)
  if (!on && m.used >= m.seats) return { on: false, locked: true, reason: 'full' }
  return { on, locked: false }
}
